import axios from 'axios';

const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:3001';

// ── Types ──────────────────────────────────────────────────────────────────────
export interface GoogleCalendarEvent {
  id: string;
  title: string;
  description?: string;
  start: string;
  end: string;
  allDay: boolean;
  color?: string;
}

function handleError(error: any): never {
  const msg = error.response?.data?.message || error.message || 'Erro desconhecido';
  throw new Error(msg);
}

// ── API calls (sem autenticação do usuário — usa Service Account no servidor) ──

/** Retorna o e-mail da Service Account configurada no servidor */
export async function fetchServiceAccountEmail(): Promise<string | null> {
  try {
    const { data } = await axios.get(`${API_URL}/google-calendar/service-account`);
    return data.email || null;
  } catch {
    return null;
  }
}

/** Lista eventos de um calendário */
export async function fetchCalendarEvents(
  calendarId: string = 'primary',
  timeMin?: string,
  timeMax?: string,
): Promise<GoogleCalendarEvent[]> {
  try {
    const { data } = await axios.get(`${API_URL}/google-calendar/events`, {
      params: { calendarId, timeMin, timeMax },
    });
    return data;
  } catch (e) {
    handleError(e);
  }
}

/** Cria um novo evento */
export async function createCalendarEvent(
  calendarId: string,
  event: Omit<GoogleCalendarEvent, 'id'>,
): Promise<GoogleCalendarEvent> {
  try {
    const { data } = await axios.post(`${API_URL}/google-calendar/events`, { calendarId, event });
    return data;
  } catch (e) {
    handleError(e);
  }
}

/** Atualiza um evento existente */
export async function updateCalendarEvent(
  calendarId: string,
  eventId: string,
  event: Omit<GoogleCalendarEvent, 'id'>,
): Promise<GoogleCalendarEvent> {
  try {
    const { data } = await axios.put(
      `${API_URL}/google-calendar/events/${eventId}`,
      { calendarId, event },
    );
    return data;
  } catch (e) {
    handleError(e);
  }
}

/** Deleta um evento */
export async function deleteCalendarEvent(
  calendarId: string,
  eventId: string,
): Promise<void> {
  try {
    await axios.delete(`${API_URL}/google-calendar/events/${eventId}`, {
      params: { calendarId },
    });
  } catch (e) {
    handleError(e);
  }
}

